<!--<h1>{{IsShowDetail}}</h1>-->
<div *ngIf='!IsShowDetail'>
  <div class="modal-header">
    <h4 class="modal-title">Certifications</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Form actions layout section start -->
    <section id="form-action-layouts">


      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="card">

            <div class="card-body">
              <div class="px-3">
                <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">


                  <div class="form-body">
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput1">Certificate Type</label>

                        <!--<CodeTypeValue CodeType="CRTYP" id="CurrentActorCertificationRequest.CredentialType" [(ngModel)]="CurrentActorCertificationRequest.CredentialType" name="CurrentActorCertificationRequest.CredentialType" required></CodeTypeValue>-->
                        <CustomDataByRequestType RequestedType="CredentialTypeByGroup" CustomType="ActorCertifications" id="CurrentActorCertificationRequest.CredentialTypeCode"
                                                 [(ngModel)]="CurrentActorCertificationRequest.CredentialTypeCode" name="CurrentActorCertificationRequest.CredentialTypeCode" required
                                                 (keyChange)="onCredentialTypeByGroup($event)">
                        </CustomDataByRequestType>
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Certificate Number</label>
                        <input type="text" class="form-control" id="CurrentActorCertificationRequest.CredentialNumber" [(ngModel)]="CurrentActorCertificationRequest.CredentialNumber" name="CurrentActorCertificationRequest.CredentialNumber" placeholder="CredentialNumber" >
                      </div>
                    </div>


                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput4">Issue Date</label>
                        <input type="date" class="form-control" id="CurrentActorCertificationRequest.ValidFrom" [(ngModel)]="CurrentActorCertificationRequest.ValidFrom" name="CurrentActorCertificationRequest.ValidFrom" placeholder="ValidFrom" >
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Expiring Date</label>
                        <input type="date" class="form-control" id="CurrentActorCertificationRequest.ValidTo" [(ngModel)]="CurrentActorCertificationRequest.ValidTo" name="CurrentActorCertificationRequest.ValidTo" placeholder="ValidTo" >
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Issuing Authority</label>

                        <CodeTypeValue CodeType="CTIAT" id="CurrentActorCertificationRequest.IssuingAuthority" [(ngModel)]="CurrentActorCertificationRequest.IssuingAuthority" name="CurrentActorCertificationRequest.IssuingAuthority" ></CodeTypeValue>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Additional Details</label>
                        <input type="text" class="form-control" id="CurrentActorCertificationRequest.AdditionalDetails" [(ngModel)]="CurrentActorCertificationRequest.AdditionalDetails" name="CurrentActorCertificationRequest.AdditionalDetails" placeholder="AdditionalDetails" >
                      </div>
                    </div>
                    <!--<div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Remarks</label>
                        <input type="text" class="form-control" id="CurrentActorCertificationRequest.Remarks" [(ngModel)]="CurrentActorCertificationRequest.Remarks" name="CurrentActorCertificationRequest.Remarks" placeholder="Remarks" >
                      </div>
                    </div>-->
                    <div class="form-group">
                      <div class="col-md-12">
                        <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-pink btn-block btn-raised">Submit</button>

                      </div>
                    </div>


                  </div>


                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // Form actions layout section end -->
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
  </div>
</div>
<div *ngIf='IsShowDetail'>
  <div class="modal-header">
    <h4 class="modal-title">Detail Identity</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Form actions layout section start -->
    <section id="form-action-layouts">


      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="card">

            <div class="card-body">
              <div class="px-3">
                <detail-grid *ngIf="CurrentActorCertificationsInfoControllerByCode"
                             [columns]="dcolumns" [data]="CurrentActorCertificationsInfoControllerByCode">

                </detail-grid>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // Form actions layout section end -->
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
  </div>
</div>
